import {
    ApiOperatorTaskSource,
    ApiUserRole,
    type OrderResponse,
    type ChatDialogResponse,
} from '@/core/generated/api';
import type { ChatSummary } from '@/entities/Chat/model/types';
import type { OperatorTaskOrigin } from '@/entities/OperatorTask/model/types';

/** Подставляет открытый заказ в новую задачу */
export const orderToTaskOrigin = (order: OrderResponse | null): OperatorTaskOrigin | null => {
    if (!order?.id) return null;

    const number = Number(order.orderNumber);

    return {
        source: ApiOperatorTaskSource.Order,
        related: {
            id: order.id,
            orderNumber: Number.isSafeInteger(number) && number > 0
                ? number
                : undefined,
            label: `Заказ № ${order.orderNumber ?? order.id}`,
            availability: {
                id: 'available',
                name: 'Доступен'
            },
        },
    };
};

/** Подставляет выбранный диалог поддержки в новую задачу */
export const chatToTaskOrigin = (chat: ChatSummary | null): OperatorTaskOrigin | null => {
    if (!chat?.id || !chat.companion.id) return null;

    return {
        source: ApiOperatorTaskSource.Chat,
        related: {
            chatId: chat.id,
            companionAppUserId: chat.companion.id,
            companionRole: {
                id: chat.companion.role === 'Client'
                    ? ApiUserRole.Client
                    : ApiUserRole.Executor,
                name: chat.companion.displayNameRole,
            },
            label: `Чат: ${chat.companion.name}`,
            availability: {
                id: 'available',
                name: 'Доступен'
            },
        },
    };
};

/** Подставляет внешний диалог Salesbot в новую задачу */
export const salebotDialogToTaskOrigin = (
    dialog: ChatDialogResponse | null
): OperatorTaskOrigin | null => {
    if (!dialog?.id) return null;

    return {
        source: ApiOperatorTaskSource.Chat,
        related: {
            chatId: dialog.id,
            label: `Диалог Salesbot: ${dialog.companionName ?? ''}`,
            availability: {
                id: 'available',
                name: 'Доступен'
            },
        },
    };
};

/** Подставляет переписку приложения в новую задачу */
export const appDialogToTaskOrigin = (
    dialog: ChatDialogResponse | null
): OperatorTaskOrigin | null => {
    const role = dialog?.companionRole?.id;

    const participantKnown = dialog?.id && dialog.companionAppUserId
        && (role === ApiUserRole.Client || role === ApiUserRole.Executor);

    if (!participantKnown) return null;
    return {
        source: ApiOperatorTaskSource.Chat,
        related: {
            chatId: dialog.id,
            companionAppUserId: dialog.companionAppUserId,
            companionRole: dialog.companionRole,
            label: `Чат: ${dialog.companionName ?? ''}`,
            availability: {
                id: 'available',
                name: 'Доступен'
            },
        },
    };
};
